import React from 'react';
interface Props {
  fillColor?: string;
}
function Hearing({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_851_3532)">
        <path
          d="M10.5 6.89453C10.5 4.41016 8.48438 2.39453 6 2.39453C3.51562 2.39453 1.5 4.41016 1.5 6.89453V12.3945C1.5 14.0508 2.84375 15.3945 4.5 15.3945C6.15625 15.3945 7.5 14.0508 7.5 12.3945C7.5 11.7164 7.84062 11.0633 8.43125 10.682C9.67812 9.87891 10.5 8.48203 10.5 6.89453ZM12 6.89453C12 9.01328 10.9031 10.8758 9.24375 11.9414C9.09062 12.0414 9 12.2102 9 12.3945C9 14.8789 6.98438 16.8945 4.5 16.8945C2.01562 16.8945 0 14.8789 0 12.3945V6.89453C0 3.58203 2.6875 0.894531 6 0.894531C9.3125 0.894531 12 3.58203 12 6.89453ZM4 6.89453V7.52578C4 7.61953 4.05312 7.70703 4.1375 7.75078L4.575 7.96953C5.14062 8.25391 5.49687 8.83203 5.49687 9.46328C5.49687 9.96016 5.27812 10.4289 4.89687 10.7477L3.72813 11.7227C3.40938 11.9883 2.9375 11.9445 2.67188 11.6258C2.40625 11.307 2.45 10.8352 2.76875 10.5695L3.9375 9.59453C3.975 9.56328 4 9.51328 4 9.46328C4 9.39766 3.9625 9.33828 3.90625 9.31016L3.46875 9.09141C2.875 8.79453 2.5 8.18828 2.5 7.52578V6.89453C2.5 4.96016 4.06563 3.39453 6 3.39453C7.93437 3.39453 9.5 4.96016 9.5 6.89453V7.14453C9.5 7.56016 9.16562 7.89453 8.75 7.89453C8.33438 7.89453 8 7.56016 8 7.14453V6.89453C8 5.79141 7.10313 4.89453 6 4.89453C4.89687 4.89453 4 5.79141 4 6.89453Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3532">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.894531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Hearing;
